import { useUser } from 'hooks';
import { useMemo } from 'react';
import { Navigate } from 'react-router-dom';
const Root = () => {
    const [loggedInUser] = useUser();

    const getRootUrl = () => {
        if (!loggedInUser) {
            return 'login';
        }
        // console.log('Loggedin user type', loggedInUser.user);
        // else if (iaqOnlyUser) return `/customer/iaq`;
        switch (loggedInUser.user.type) {
            // case 'Admin':
            //     return '/admin/pages/admindashboard';
            // case 'Customer':
            //     return '/customer/dashboard';
            // case 'uvCustomer':
            //     return '/customer/uv';
            default:
                return '/customer/ClairCount';
            // '/customer/dashboard';
        }
    };

    const url = getRootUrl();

    return <Navigate to={url} />;
};

export default Root;
